export default __webpack_public_path__ + "static/media/other-users-artists-mobile.9dd83f91.svg";